import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS9 = props => {
    const ans = '學習行為'
    const select_arr = [
        {
            value: '1',
            label: '專心'
        },
        {
            value: '2',
            label: '積極努力'
        },

        {
            value: '3',
            label: '有恆心'
        },
        {
            value: '4',
            label: '沈思好問'
        },
        {
            value: '5',
            label: '分心'
        },
        {
            value: '6',
            label: '被動馬虎'
        },
        {
            value: '7',
            label: '半途而廢'
        },
        {
            value: '8',
            label: '偏心某科'
        },

    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s9"
                   type="checkbox"/>
        </div>
    )
}

export default SseS9


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS9.jsx